import React, { useEffect, useState } from 'react'
import LoginCSS from './login.module.css'
import Logo from '../../assets/logo.svg'
import Alert from '../../components/Alert/Alert'
import { useNavigate } from 'react-router-dom'
import { userService } from '../../services/user.service'
import LoaderBtn from '../../components/LoaderBtn/LoaderBtn'
import { hasActiveAdminSession, startAdminSession } from '../../utils/functions/auth'
const Login = () => {
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [stateButton, setStateButton] = useState('INGRESAR')
  const [alert, setAlert] = useState(null)

  useEffect(() => {
    if (hasActiveAdminSession()) {
      navigate('/admin/home')
    }
  }, [navigate])

  const handleSubmit = async e => {
    e.preventDefault()
    setStateButton(<LoaderBtn />)
    setTimeout(async () => {
      try {
        const response = await userService.signIn({ username, password })

        if (response.data.status === 200) {
          setAlert({ variant: 'success', msg: response.data.message })
          startAdminSession(response.data.username, response.data.token)

          setTimeout(() => {
            navigate('/admin/home')
          }, 2000)
        } else {
          setAlert({ variant: 'danger', msg: response.data.message })
          setStateButton('INGRESAR')

          setTimeout(() => {
            setAlert(null)
          }, 2500)
        }
      } catch (error) {
        setAlert({
          variant: 'danger',
          msg: 'No se pudo conectar con el servidor. Intentá nuevamente.'
        })
        setStateButton('INGRESAR')

        setTimeout(() => {
          setAlert(null)
        }, 2500)
      }
    }, 1500)
  }
  return (
    <>
      <Alert alert={alert} />
      <div className={LoginCSS.containerAdmin}>
        <header className={LoginCSS.headerAdmin}>
          <img src={Logo} alt='' />
        </header>
        <div className={LoginCSS.admin}>
          <h1>Ingresá</h1>
          <form
            onSubmit={e => handleSubmit(e)}
            action=''
            className={LoginCSS.formAdmin}
          >
            <div className={LoginCSS.input}>
              <label htmlFor='username'>Usuario</label>
              <input
                type='text'
                id='username'
                name='username'
                className={LoginCSS.username}
                onChange={e => setUsername(e.target.value)}
              />
            </div>
            <div className={LoginCSS.input}>
              <label htmlFor='password'>Contraseña</label>
              <input
                type='password'
                id='password'
                name='password'
                className={LoginCSS.password}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
            <button type='submit'>{stateButton}</button>
          </form>
        </div>
      </div>
    </>
  )
}

export default Login
